export default [
  {
    path: "/cashouts",
    component: () => import(/* webpackChunkName: "cashouts" */ "./layout"),

    children: [
      {
        path: "/",
        name: "cashouts.index",
        component: () => import(/* webpackChunkName: "cashouts" */ "./index"),
      },
      {
        props: true,
        path: ":id",
        name: "cashouts.show",
        component: () => import(/* webpackChunkName: "cashouts" */ "./show"),
      },
    ],
  },
];
